module.exports = __webpack_public_path__ + "img/mainFunction-icon1.cbf01ea0.png";